import history from 'store/history';

/**
 * Get all the info about the current router.
 *
 * @method getRouter
 * @param  {Object}  state The current state
 * @return {Object}        The router info
 */
export const getRouter = () => ({ location: history.location });

/**
 * Get the current location from redux store.
 *
 * @method getLocation
 * @param  {Object}    state The current state
 * @return {Object}          The location info
 */
export const getLocation = () => history.location;
